// src/services/UserService.js

import axios from 'axios';
import config from '../config';

const UserService = {

  // Fetch current user's data
  getMe: async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${config.apiBaseUrl}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;  // This contains user data like name, email, role, etc.
    } catch (error) {
      console.error('Error fetching user data:', error);
      throw error;
    }
  },
  
  getAll: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/users`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  get: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  create: async (data) => {
    const token = localStorage.getItem('token');
    const response = await axios.post(`${config.apiBaseUrl}/users`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  update: async (id, data) => {
    const token = localStorage.getItem('token');
    const response = await axios.put(`${config.apiBaseUrl}/users/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  delete: async (id) => {
    const token = localStorage.getItem('token');
    const response = await axios.delete(`${config.apiBaseUrl}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  // Fetch roles, departments, and countries for dropdowns
  getRoles: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/roles`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  getDepartments: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/departments`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },

  getCountries: async () => {
    const token = localStorage.getItem('token');
    const response = await axios.get(`${config.apiBaseUrl}/countries`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  },
};

export default UserService;
